export enum Layer {
  ORIGINAL = 'original',
  TRANSLATED = 'translated',
}

export const LAYERS: Layer[] = Object.values(Layer);
